module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_disconnect-491c26b4d8e4ec2c227917f44e65c792.svg";